import Portal from "../layout/Portal";
import Modal from "../layout/Modal";
import React, {Fragment} from "react";
import LocationEditor from "./locationEditor";
import Empty from "../layout/Empty";
import Button from "../form/Button";
import {connect} from "src/store";

const NewLocationEditor = (props) => <Portal>
    <Modal
        size="large"
        state="on"
        header={props.presets?.partner ? "Saját helyszín adatai" : "Külsős helyszín adatai"}
        buttons={[
            {
                text: "Bezárás",
                props: {color: "default", disabled: props.disabled || props.isLoading},
                onClose: true,
                onClick: async () => {
                    props.pristineForm && await props.pristineForm();
                    props.onNewLocationEditorClose();
                }
            },
            {
                text: "Mentés",
                props: {color: "primary", disabled: props.disabled || props.isLoading},
                onClose: true,
                onClick: async () => {
                    props.onNewLocationEditorSaved(props.saveForm && await props.saveForm());
                    props.pristineForm && await props.pristineForm();
                    props.onNewLocationEditorClose();
                }
            },
        ]}
    >
        {props.children}
    </Modal>
</Portal>;

class NewLocationButton extends React.Component<any, any> {

    state = {
        opened: false,
        partner: undefined
    }

    render() {

        let content;
        if (this.state.opened && this.state.partner !== undefined) {
            content = <LocationEditor
                gridid="eventEditorLocationList"
                editorContext="eventEditorLocation"
                presets={{partner: this.state.partner?.partner_id || null}}
                isLoading={this.props.isLoading}
                onNewLocationEditorClose={() => this.setState({opened: false, partner: undefined})}
                onNewLocationEditorSaved={(location) => this.props.saveChanges(location)}
                editor={NewLocationEditor}
                list={Empty}
                selection={null}
            />;
        } else {
            content = <Portal>
                <Modal
                    state={this.state.opened}
                    size="medium"
                    header="Új helyszín felvitele"
                    buttons={[
                        {
                            text: "Saját helyszín",
                            onClick: () => {
                                this.setState({
                                    partner: this.props.partner
                                })
                            }
                        },
                        {
                            text: "Külsős helyszín",
                            onClick: () => {
                                this.setState({
                                    partner: null
                                })
                            }
                        },
                        {
                            text: "Mégse",
                            onClose: true,
                            onClick: () => {
                                this.setState({opened: false, partner: undefined});
                            }
                        }
                    ]}
                >
                </Modal>
            </Portal>;
        }

        return (
            <Fragment>
                {content}
                <Button
                    color="default"
                    tooltip="Új helyszín felvitele"
                    icon={{lib: "fas", name: "plus"}}
                    onClick={() => {
                        this.setState({opened: true});
                    }}
                />
            </Fragment>
        );
    }
}

export default connect((state) => {
    return {
        partner: state.app.context.partner
    }
})(NewLocationButton);